import { Command } from 'commander';
import { VaultStoreService } from '../../services/vault-store.service.js';

interface DeleteOptions {
    json?: boolean;
}

export function createVaultDeleteCommand(): Command {
    return new Command('delete')
        .description('Soft-delete a vault item and keep an encrypted tombstone for sync')
        .argument('<id>', 'Vault item id')
        .option('-j, --json', 'Output JSON')
        .action(async function (this: Command, id: string, options: DeleteOptions) {
            const store = new VaultStoreService();
            if (!(await store.exists())) {
                throw new Error('Vault is not initialized. Run `j vault init` first.');
            }

            const item = await store.deletePlainItem(id);
            const useJson = !!(options.json || this.optsWithGlobals().json);
            if (useJson) {
                console.log(JSON.stringify({ item }, null, 2));
                return;
            }
            console.log(`Deleted vault item: ${id}`);
        });
}
